<template>
    <div class="text-muted">
        <template v-if="publishedDate">
            <template v-if="!job.is_published">sera</template>
            publié le <span class="text-nowrap">{{ publishedDate }}</span> <span class="mx-1">•</span>
        </template>
        <template v-if="deadlineDate">
            <span class="text-nowrap">date limite de candidature :</span> <span class="text-nowrap">{{ deadlineDate }}</span>
        </template>
    </div>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        props: {
            job: Object,
        },
        computed: {
            publishedDate() {
                return this.job.published_at
                    ? dayjs(this.job.published_at).format('DD MMMM YYYY')
                    : null;
            },
            deadlineDate() {
                return this.job.application_deadline
                    ? dayjs(this.job.application_deadline).format('DD MMMM YYYY')
                    : null;
            },
        }
    }
</script>
